export class CodeSearchSession {
  private completed = false;

  reset(): void {
    this.completed = false;
  }

  acceptConfirmed(identifier: string): string | undefined {
    if (this.completed) {
      return undefined;
    }
    this.completed = true;
    return identifier;
  }
}
